export interface CodeInputProps {
  handleNext: any
}

export const INPUTS_NUMBER = 6

export interface inputProps {
  error: boolean
}
